import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MeteringConceptType } from "../../site-status-types";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getMeteringConceptTypeColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: `Meldetyp`,
    accessorKey: "meteringConceptType",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: Object.values(MeteringConceptType)
    },
    filterFn: (row, _, filterValue) => {
      // manual filtering necessary because "-" in included in all values -> equals instead of includes required
      if (filterValue.length === 0) {
        return true;
      }

      const rowValue = row.original.meteringConceptType;
      return filterValue.some((filter) => filter === rowValue);
    },
    enableGlobalFilter: false
  };
}

export { getMeteringConceptTypeColumn };
